<template>
  <div :class="className" :style="{height:height,width:width,zoom:barzoom}"/>
</template>

<script>
import * as echarts from 'echarts';
import {iswindows} from '@/utils/utils'
require('echarts/theme/macarons') // echarts theme
// import { debounce } from '@/utils'

export default {
  computed:{
    barzoom(){
      let zoom=window.devicePixelRatio
      // console.log(zoom)
      // return iswindows()?zoom:1
      return 1;
    }
  },
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    legendData:{
      type:Array,
      default:()=>[]
    },
    series:{
      type:Array,
      default:()=>[]
    },
       type:{
      type:String,
      default:''
    }
  },
  watch:{
    series:{
      deep: true,
      // immediate: true,
      handler(newvalue, oldvalue) {
        if(newvalue){
          this.initChart()
        }
      }
    }
  },
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.initChart()
    this.__resizeHandler = this._.debounce(() => {
      if (this.chart) {
        this.chart.resize()
      }
    }, 100)
    window.addEventListener('resize', this.__resizeHandler)
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    window.removeEventListener('resize', this.__resizeHandler)
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      let that=this
      this.chart = echarts.init(this.$el, 'macarons')

      this.chart.setOption({
        tooltip: {
          trigger: 'item',
          // formatter: '{a} <br/>{b} : {c} ({d}%)'
          formatter: function (params) {
            if(that.type=='gender'){
             return params.data.datas[0]+'人,'+'￥'+params.data.datas[1]
            }

          },
        },
        legend: {
          left: 'center',
          bottom: '10',
          data: this.legendData
        },
        calculable: true,
        series: this.series
        // [
        //   {
        //     name: 'WEEKLY WRITE ARTICLES',
        //     type: 'pie',
        //     radius: 95,
        //     center: ['50%', '38%'],
        //     data: [
        //       { value: 320, name: 'Industries' },
        //       { value: 240, name: 'Technology' },

        //     ],
        //     animationEasing: 'cubicInOut',
        //     animationDuration: 2600
        //   }
        // ]
      })
    }
  }
}
</script>
